import React, { Component } from "react";
import PropTypes from "prop-types";
import moment from "moment";
import List from "react-md/lib/Lists/List";
import ListItem from "react-md/lib/Lists/ListItem";
import Subheader from "react-md/lib/Subheaders";
import Button from "react-md/lib/Buttons/Button";
import { getUserType, RegistrationShape } from "../../../utils";

class RegistrationFlags extends Component {
  constructor(props) {
    super(props);
    this.handleClearAllFlags = this.handleClearAllFlags.bind(this);
  }

  handleClearAllFlags() {
    const { onClearAllFlags, rangeLocation, editQueueItem } = this.props;
    onClearAllFlags(rangeLocation, editQueueItem.registrationId);
  }

  render() {
    const { editQueueItem: registration } = this.props;
    //check if main user has issues
    const hasIssue =
      registration.group[0].issues &&
      Object.keys(registration.group[0].issues).length > 0;

    const hasFlaggedQuestion =
      registration.group.filter(
        (user) => user.flaggedQuestions && user.flaggedQuestions.length > 0
      ).length > 0;

    const hasFlaggedMembershipMessages = registration.group.some(
      (user) =>
        user.flaggedMembershipMessages &&
        user.flaggedMembershipMessages.length > 0
    );

    return (
      <div className="md-grid">
        <div className="md-cell md-cell--12">
          <List
            className="md-cell md-cell--12 md-paper md-paper--1"
            style={{
              maxHeight: "calc(100vh - 330px)",
              overflowY: "auto",
            }}
          >
            {hasFlaggedMembershipMessages &&
              registration.member &&
              registration.active && (
                <Subheader
                  primaryText="Flagged Membership"
                  style={{ color: "black", fontSize: "larger" }}
                />
              )}
            {hasFlaggedMembershipMessages &&
              registration.member &&
              registration.active &&
              registration.group.map(
                /* eslint-disable no-confusing-arrow */
                // prettier auto remove surrouding () which need to avoid this lint error
                (user, i) =>
                  user.flaggedMembershipMessages &&
                  user.flaggedMembershipMessages.length > 0 ? (
                    /* eslint-enable no-confusing-arrow */
                    // There is no unique parameter (firstName and lastName of user may be the same)
                    //     so we use index for key
                    /* eslint-disable react/no-array-index-key */
                    <div key={i}>
                      {/* eslint-enable react/no-array-index-key */}
                      <Subheader
                        primaryText={`${user.firstName} ${user.lastName} ${
                          getUserType(user) ? getUserType(user) : ""
                        }`}
                      />
                      {user.flaggedMembershipMessages &&
                        user.flaggedMembershipMessages.map((message) => (
                          <ListItem key={message} primaryText={message} />
                        ))}
                    </div>
                  ) : null
              )}
            {registration.member &&
              registration.hasOwnProperty("active") &&
              !registration.active && (
                <Subheader
                  primaryText="Inactive Member"
                  style={{ color: "black", fontSize: "larger" }}
                />
              )}
            {registration.type && (
              <ListItem key="type" primaryText={`Type: ${registration.type}`} />
            )}
            {registration.sku && (
              <ListItem key="sku" primaryText={`Sku: ${registration.sku}`} />
            )}
            {hasFlaggedQuestion && (
              <Subheader
                primaryText="Flagged Questions"
                style={{ color: "black", fontSize: "larger" }}
              />
            )}
            {hasFlaggedQuestion &&
              registration.group.map(
                /* eslint-disable no-confusing-arrow */
                // prettier auto remove surrouding () which need to avoid this lint error
                (user, i) =>
                  user.flaggedQuestions && user.flaggedQuestions.length > 0 ? (
                    /* eslint-enable no-confusing-arrow */
                    // There is no unique parameter (firstName and lastName of user may be the same)
                    //     so we use index for key
                    /* eslint-disable react/no-array-index-key */
                    <div key={i}>
                      {/* eslint-enable react/no-array-index-key */}
                      <Subheader
                        primaryText={`${user.firstName} ${user.lastName} ${
                          getUserType(user) ? getUserType(user) : ""
                        }`}
                      />
                      {user.flaggedQuestions &&
                        user.flaggedQuestions.map((question) => (
                          <ListItem
                            key={question.text}
                            primaryText={question.text}
                          />
                        ))}
                    </div>
                  ) : null
              )}
            {hasIssue && (
              <Subheader
                primaryText={`Issues (${
                  Object.keys(registration.group[0].issues).length
                })`}
                style={{ color: "black", fontSize: "larger" }}
              />
            )}
            {hasIssue &&
              Object.keys(registration.group[0].issues).map((issueKey) => {
                const issue = registration.group[0].issues[issueKey];
                return (
                  <ListItem
                    key={issueKey}
                    primaryText={issue.text}
                    secondaryText={moment(issue.updated).format(
                      "M/D/YYYY h:mm a"
                    )}
                  />
                );
              })}
          </List>
        </div>
        {registration.flagged && (
          <div className="md-cell md-cell--12">
            <Button
              primary
              raised
              label="Clear all flags"
              onClick={this.handleClearAllFlags}
            />
          </div>
        )}
      </div>
    );
  }
}

RegistrationFlags.propTypes = {
  onClearAllFlags: PropTypes.func.isRequired,
  rangeLocation: PropTypes.string.isRequired,
  editQueueItem: RegistrationShape,
};

RegistrationFlags.defaultProps = {
  editQueueItem: null,
};

export default RegistrationFlags;



// WEBPACK FOOTER //
// ./src/staff/components/QueueItemDrawer/RegistrationFlags/RegistrationFlags.jsx